// extracted by mini-css-extract-plugin
export default {"card":"sectionCard_card__IBfph"};